import css from 'styled-jsx/css'

import { colors, sizes } from '../../theme'
import common from '../../theme/common'


export default css`
  li {
    background: ${colors.pureWhite};
    padding: 3rem;
    padding-bottom: 8rem;
    width: 30rem;
    list-style-type: none;
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    position: relative;
    transition: all 150ms ease;
  }

  li :global(.icon) {
    position: absolute;
    right: -2rem;
    bottom: -2rem;
    height: 10rem;
    width: 10rem;
  }

  li :global(.icon img) {
    width: 100%;
    height: 100%;
  }

  li :global(p.title) {
    ${common.title};

    font-family: 'Taviraj-Light', serif;
    color: ${colors.almostBlack};
    margin-bottom: 1.5rem;
  }

  li :global(p.description) {
    ${common.text};

    font-family: 'Open Sans Regular', sans-serif;
    color: ${colors.darkerGrey};
  }

  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    li {
      margin-bottom: 3rem;
      width: 100%;
    }

    li :global(p.description) {
      max-width: 60rem;
    }

    li :global(.icon) {
      position: absolute;
      right: 0;
      bottom: -2.5rem;
    }
  }

  @media screen and (min-width: ${sizes.media.tablet.maxWidth}) {
    li {
      transform: translateY(0) scale(1);
    }

    li:hover {
      transform: translateY(-0.2rem) scale(1.05);
      box-shadow: 0 5px 40px rgba(0, 0, 0, 0.05);
    }
  }
`
